import { Button, Group, Text } from "@mantine/core";
import { modals } from "@mantine/modals";
import { IconCheck, IconX } from "@tabler/icons-react";
import {
  deleteUserComment,
  deleteUserCommentReply,
} from "../../../api/ApiUserComment";

const DeleteView = ({ idItem, isEditMode, onClose }: DeleteProduct) => {
  const handleDeleteUserComment = async () => {
    await (isEditMode
      ? deleteUserComment(idItem)
      : deleteUserCommentReply(idItem));
    onClose((prev: any) => !prev);
    modals.closeAll();
  };

  return (
    <div>
      <Text size="24px">
        Bạn có chắc chắn muốn xóa các {isEditMode ? "bình luận" : "phản hồi"}{" "}
        này ?
      </Text>
      <Group justify="center" mt="lg">
        <Button
          type="button"
          color="#3598dc"
          onClick={handleDeleteUserComment}
          leftSection={<IconCheck size={18} />}
        >
          Xóa
        </Button>
        <Button
          type="button"
          color="#3598dc"
          onClick={() => modals.closeAll()}
          leftSection={<IconX size={18} />}
        >
          Hủy
        </Button>
      </Group>
    </div>
  );
};

type DeleteProduct = {
  idItem: number[];
  isEditMode: any;
  onClose: any;
};

export default DeleteView;
